import { WebUser } from 'types/User';
import { createMandatoryContext } from './utils';

interface WebUserContextType {
  webUser: WebUser;
}

const [useWebUserContext, WebUserProvider] = createMandatoryContext<WebUserContextType>();

export { useWebUserContext, WebUserProvider };